import React from 'react';

import { type ITenantFooter } from '@/common/types/tenant-config.types';
import { selectDomain, useDomainStore } from '@/store/use-domain.store';

import DesktopFooter from './components/desktop-footer.component';
import MobileFooter from './components/mobile-footer.component';

export function DefaultFooter() {
  const config = useDomainStore(selectDomain);
  if (!config) {
    return null;
  }
  const footer: ITenantFooter = {
    address: config.address,
    description: config.description,
    logoUrl: config.logoUrl,
    nemads: config.nemads,
    pagesStatus: config.pagesStatus,
    socialMedias: config.socialMedias,
    tels: config.tels,
    mobiles: config.mobiles,
    title: config.title,
  };
  return (
    <>
      <div className="block lg:hidden">
        <MobileFooter
          footerData={footer}
          isContactUsEnabled={config.pagesStatus.contentContactUs}
        />
      </div>
      <div className="hidden lg:block">
        <DesktopFooter
          footerData={footer}
          isContactUsEnabled={config.pagesStatus.contentContactUs}
        />
      </div>
    </>
  );
}
